export default "__VITE_ASSET__026dbecd__$_?component__"